import LegalLayout from "./LegalLayout";
export default function Termini() {
  return (
    <LegalLayout title="Termini e condizioni">
      <p>
        Vinko è un assistente virtuale che presenta bookmaker, promozioni e
        servizi legati al mondo delle scommesse. Vinko non gestisce denaro,
        depositi, prelievi o giocate: ogni operazione avviene esclusivamente sui
        siti ufficiali dei rispettivi operatori. Il servizio è riservato ai
        maggiori di 18 anni.
      </p>
      <p>Le promozioni indicate sono a titolo informativo e possono essere modificate o sospese dai bookmaker senza preavviso.</p>
      <p>Il testo definitivo dovrà essere verificato da un professionista.</p>
    </LegalLayout>
  );
}
